import { CR_SUBMISSION } from '../constants';

export type GetCurrentSelectedRatingInputParams = {
    rootElement: Pick<HTMLElement, 'querySelectorAll'>;
};
export const getCurrentSelectedRatingInput = ({ rootElement }: GetCurrentSelectedRatingInputParams) => {
    const ratingInputs = rootElement.querySelectorAll<HTMLInputElement>(CR_SUBMISSION.STAR_RATING.RATING_INPUTS_SELECTOR);
    return Array.from(ratingInputs).find(({ checked }) => checked);
};
